// @generated-imports
import { showToast } from './app.js';
import { CONFIG, dom, state } from './core.js';
import { trapFocusInTopLayer } from './layers.js';
import { renderSettingsList } from './platform.js';
// @generated-imports
/* ===========================================================================
   MODO LEVE, PERSISTÊNCIA DE ARMAZENAMENTO E FOCUS TRAP (v1.2.0)
   ---------------------------------------------------------------------------
   TVs, TV boxes e mini PCs sofrem com blur/blend/animações do portal. O
   modo leve corta tudo isso via CSS (body.is-lite) e desliga o fundo
   borrado do EmulatorJS na próxima sessão (param lite=1 ao player).
   ======================================================================== */

/** Rolagem suave vira instantânea no modo leve (smooth scroll custa caro em
 *  GPU fraca e ainda atrapalha a navegação por controle na TV). */
function smoothBehavior() {
  return state.liteMode ? 'auto' : 'smooth';
}

function initLiteMode() {
  let saved = null;
  try { saved = localStorage.getItem(CONFIG.localStorageLiteKey); } catch (_) {}
  if (saved === '1' || saved === '0') {
    state.liteMode = saved === '1';
  } else {
    // Primeira visita: heurística de hardware fraco, agora conservadora —
    // a v1.2 ligava com cores <= 4 sozinho e pegava iPhones e quad-cores
    // perfeitamente capazes. Regra: com os DOIS sinais presentes, exige os
    // dois; com um só, corte bem mais baixo; na dúvida, modo completo
    // (o usuário sempre pode ligar no botão ⚡). saveData explícito do
    // usuário também liga.
    const memory = navigator.deviceMemory;
    const cores = navigator.hardwareConcurrency;
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);
    let weakHardware = false;
    if (typeof memory === 'number' && typeof cores === 'number') {
      weakHardware = memory <= 4 && cores <= 4;
    } else if (typeof cores === 'number') {
      weakHardware = cores <= 2;
    } else if (typeof memory === 'number') {
      weakHardware = memory <= 2;
    }
    state.liteMode = weakHardware || saveData;
    if (state.liteMode) {
      showToast('⚡ Modo leve ativado automaticamente para este dispositivo — dá para desligar no botão ⚡ do topo.');
    }
  }
  applyLiteMode();
}

function applyLiteMode() {
  document.body.classList.toggle('is-lite', state.liteMode);
  // scroll-behavior mora no <html> via CSS; sobrescrever inline evita
  // depender de :has() (ausente em navegador de TV antigo).
  document.documentElement.style.scrollBehavior = state.liteMode ? 'auto' : '';
  // O interruptor do modo leve vive no painel ⚙️ Configurações (v1.6).
  if (dom.settingsModal && !dom.settingsModal.classList.contains('is-hidden')) {
    renderSettingsList();
  }
}

function toggleLiteMode() {
  state.liteMode = !state.liteMode;
  try { localStorage.setItem(CONFIG.localStorageLiteKey, state.liteMode ? '1' : '0'); } catch (_) {}
  applyLiteMode();
  showToast(state.liteMode
    ? '⚡ Modo leve ligado. O fundo borrado do emulador some no próximo jogo carregado.'
    : 'Modo leve desligado — efeitos visuais completos.');
}

/** Pede ao navegador para tratar nosso armazenamento como persistente:
 *  TVs e Android limpam IndexedDB sob pressão de espaço, e os save states
 *  moram lá. Chamado uma vez, no primeiro jogo carregado com sucesso. */
async function tryPersistStorage() {
  if (state.storagePersisted) return;
  state.storagePersisted = true;
  try {
    if (navigator.storage && typeof navigator.storage.persist === 'function') {
      await navigator.storage.persist();
    }
  } catch (_) { /* melhor esforço — sem persist() os saves continuam funcionando */ }
}

/* --- Focus trap: Tab não escapa dos modais abertos --- */

const FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function setupModalFocusTrap() {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    trapFocusInTopLayer(event);
  });
}

// @generated-exports
export { FOCUSABLE_SELECTOR, applyLiteMode, initLiteMode, setupModalFocusTrap, smoothBehavior, toggleLiteMode, tryPersistStorage };
// @generated-exports
